import { render, staticRenderFns } from "./CardCreateSlug.vue?vue&type=template&id=122ba41e&scoped=true&"
import script from "./CardCreateSlug.vue?vue&type=script&lang=js&"
export * from "./CardCreateSlug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122ba41e",
  null
  
)

export default component.exports